// extracted by mini-css-extract-plugin
export var paginationContainer = "_6r-0";